import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import AddInspectionAgencyEEForm from '../Components/AddInspectionAgencyEEForm';

export default function AddInspectionAgencyEEPage() {
  return (
    // component="main"
    <Box  sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <AddInspectionAgencyEEForm/>
      </Container>
    </Box>
  )
}
